export default __webpack_public_path__ + "static/media/02AW1JAN66.325e7058.jpg";